<template>
	<div
		class="serenity__card"
		:style="
			`background: ${background}; width: ${width}; height: ${height}; margin-top: ${mt}; margin-bottom: ${mb}; margin-left: ${ml}; margin-right: ${mr}; padding: ${padding}; border-radius: ${borderRadius ? borderRadius : `10px`};`
		"
	>
		<slot></slot>
	</div>
</template>

<script>
export default {
	props: {
		width: String,
        height: String,
        background: String,
		mt: String,
		mb: String,
		ml: String,
		mr: String,
		padding: String,
        borderRadius: String
	},
};
</script>

<style lang="scss" scoped>
.serenity__card {
}
</style>
